export default __webpack_public_path__ + "static/media/test.0847a8d5.jpeg";